import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import {
  DEFAULT_DEVICE_CATEGORY_TYPES,
  DEVICE_LOCATION_SUBSET_CONFIGS,
  DeviceCategoryType,
} from '../devices-location-subset/device-location-subset.config';

@Component({
  selector: 'era-device-category-type-filter',
  templateUrl: './device-category-type-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdown, NgbDropdownMenu, NgbDropdownToggle],
})
export class DeviceCategoryTypeFilterComponent {
  public readonly options = DEVICE_LOCATION_SUBSET_CONFIGS;

  public readonly selected = input<readonly DeviceCategoryType[]>(DEFAULT_DEVICE_CATEGORY_TYPES);
  public readonly selectedChange = output<readonly DeviceCategoryType[]>();

  public isSelected(type: DeviceCategoryType): boolean {
    return this.selected().includes(type);
  }

  public readonly selectionLabel = computed(() => {
    const selectedCount = this.selected().length;
    if (selectedCount === 0) {
      return 'No categories';
    }
    if (selectedCount === DEFAULT_DEVICE_CATEGORY_TYPES.length) {
      return 'All categories';
    }
    return `${selectedCount.toString()} categories`;
  });

  public toggle(type: DeviceCategoryType): void {
    const selected = new Set(this.selected());
    if (selected.has(type)) {
      selected.delete(type);
    } else {
      selected.add(type);
    }

    this.selectedChange.emit(DEFAULT_DEVICE_CATEGORY_TYPES.filter((type) => selected.has(type)));
  }
}
